import React from 'react';
import { WithTranslation } from 'react-i18next';
import { withTranslation } from 'next-i18next';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@lb-classroom/ui';

interface PassedProps {
  t: any;
  ticket: number;
  subTicket: number;
}

type Props = WithTranslation & PassedProps;

const TicketMenu: React.FC<Props> = (props: Props) => {
  const { t, ticket, subTicket } = props;
  const totalTickets = ticket + subTicket;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="text-default font-medium focus:outline-none">
          {t('service.header.ticketCount', {
            count: totalTickets,
            smart_count: totalTickets,
          })}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuItem className="ticket-count cursor-default">
          <span>{t('service.header.regularTickets')}</span>
          <span> </span>
          <span>{ticket}</span>
        </DropdownMenuItem>
        <DropdownMenuItem className="ticket-count cursor-default">
          <span>{t('service.header.noExpirationTickets')}</span>
          <span> </span>
          <span>{subTicket}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default withTranslation('common')(TicketMenu);
